// types
import { InputType, InputProps, InputSize } from './types';

// components
import Input from './input';

export default function InputPassword({
  title,
  onChange,
  name,
  className,
  size = InputSize.MEDIUM,
  disabled,
  placeholder,
  value,
  maxLength,
  error,
  prefix,
  suffix,
  labelClassName = '',
  onBlur,
  tabIndex,
  onFocus,
  inputRef,
  withCopy,
  withShowButton,
}: InputProps): React.JSX.Element {
  return (
    <Input
      title={title}
      onChange={onChange}
      name={name}
      size={size}
      className={className}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onBlur={onBlur}
      onFocus={onFocus}
      type={InputType.PASSWORD}
      labelClassName={labelClassName}
      maxLength={maxLength}
      error={error}
      prefix={prefix}
      tabIndex={tabIndex}
      suffix={suffix}
      inputRef={inputRef}
      withCopy={withCopy}
      withShowButton={withShowButton}
    />
  );
}
